import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authProvider";

/**
 * Renders a button which, when selected, will redirect the page to the login prompt
 */
export const SignInButton = () => {
    const { instance } = useMsal();

    const handleLogin = (loginType) => {
        if (loginType === "redirect") {
            instance.loginRedirect(loginRequest).catch(e => {
                console.log(e);
            });
        }
    }
    return (
        <p className='header-username' style={{cursor: "pointer"}} onClick={() => handleLogin("redirect")}>Sign in</p>
    );
}